import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-bold text-gray-900 px-1 truncate" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col"
}

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import { PlusIcon } from "@heroicons/vue/24/solid";
import { computed, ref } from "vue";
import { Organization } from "shared/types/Organization";
import { User } from "shared/types/User";
import InviteUsersModal from "@/components/users/InviteUsersModal.vue";
import OrganizationTabUsersHierarchyItem from "@/views/organizations/components/OrganizationTabUsersHierarchyItem.vue";
import OrganizationTabUsersList from "@/views/organizations/components/OrganizationTabUsersList.vue";
import { calculateIndentation } from "@/views/organizations/organizations";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabUsersHierarchyItem',
  props: {
    organization: {},
    organizationsByParentId: {},
    usersByOrganizationId: {},
    canEdit: { type: Boolean },
    indentation: { default: 0 },
    hideFirstTopBorder: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isInviteUsersModalOpen = ref(false);

const children = computed(() => {
  const items = props.organizationsByParentId[props.organization._id] || [];
  return items.slice().sort((a, b) => a.name.localeCompare(b.name));
});

const users = computed(() => props.usersByOrganizationId[props.organization._id] || []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Disclosure), { defaultOpen: true }, {
    default: _withCtx(({ open }) => [
      _createVNode(_unref(DisclosureButton), {
        class: _normalizeClass(["flex items-center py-1 pl-2 pr-3.5 h-[50px] bg-gray-100 border-b", _ctx.hideFirstTopBorder ? '' : 'border-t']),
        style: _normalizeStyle({ paddingLeft: `${_unref(calculateIndentation)(_ctx.indentation)}px` })
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronRightIcon), {
            class: _normalizeClass([{ 'rotate-90': open }, "w-5 h-5 shrink-0"])
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.organization.name), 1),
          _hoisted_2,
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock(_unref(PlusIcon), {
                key: 0,
                class: "w-5 h-5 cursor-pointer text-gray-600 shrink-0",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isInviteUsersModalOpen.value = true), ["stop"]))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["class", "style"]),
      _createVNode(_unref(DisclosurePanel), null, {
        default: _withCtx(() => [
          _createVNode(OrganizationTabUsersList, {
            users: users.value,
            organization: _ctx.organization,
            canEdit: _ctx.canEdit,
            indentation: _ctx.indentation + 1
          }, null, 8, ["users", "organization", "canEdit", "indentation"]),
          (children.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children.value, (childOrganization) => {
                  return (_openBlock(), _createBlock(OrganizationTabUsersHierarchyItem, {
                    key: childOrganization._id,
                    organization: childOrganization,
                    organizationsByParentId: _ctx.organizationsByParentId,
                    usersByOrganizationId: _ctx.usersByOrganizationId,
                    canEdit: _ctx.canEdit,
                    indentation: _ctx.indentation + 1
                  }, null, 8, ["organization", "organizationsByParentId", "usersByOrganizationId", "canEdit", "indentation"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (isInviteUsersModalOpen.value)
        ? (_openBlock(), _createBlock(InviteUsersModal, {
            key: 0,
            existingUsers: users.value,
            organizationId: _ctx.organization._id,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (isInviteUsersModalOpen.value = false))
          }, null, 8, ["existingUsers", "organizationId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})